#import "../fragments/search-result-contact-fragment.graphql"
#import "../fragments/search-result-account-fragment.graphql"
#import "../fragments/search-result-lead-fragment.graphql"

query GetSearchResultsByType($query: String!) {
    search(query: $query) {
        quickResults {
            recentResultsByType {
                leads {
                    ...LeadSearchResultByType
                }
                accounts {
                    ...AccountSearchResultByType
                }
                contacts {
                    ...ContactSearchResultByType
                }
            }
            leadResults {
                ...LeadSearchResultByType
            }
            accountResults {
                ...AccountSearchResultByType
            }
            contactResults {
                ...ContactSearchResultByType
            }
        }
    }
}
